var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvBolt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "30px",
    viewBox: "0 0 19 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EV-Bolt",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "EV-Bolt-1",
    transform: "translate(-208.000000, -945.000000)",
    fill: "#247F38",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rebate-popover",
    transform: "translate(193.000000, 929.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(15.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uF0E7",
    transform: "translate(0.000000, 4.250038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7662175,9.0625 L10.2298672,9.0625 L12.642791,1.71055794 C12.8693535,0.849609375 12.2179864,0 11.3287175,0 L3.17246749,0 C2.49277999,0 1.91503455,0.504123688 1.82443167,1.17811394 L0.0119316739,14.7718639 C-0.0957076389,15.5875111 0.538678424,16.3125 1.35996749,16.3125 L8.08322074,16.3125 L5.47205474,27.3291016 C5.26817061,28.1900501 5.92517974,29 6.79182555,29 C7.26757361,29 7.72069861,28.7507591 7.96993949,28.3203125 L17.9386895,11.1015625 C18.4654362,10.2009544 17.814069,9.0625 16.7662175,9.0625 Z",
    id: "Path"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvBolt);
export default __webpack_public_path__ + "static/media/ev-bolt.b0716b1f.svg";
export { ForwardRef as ReactComponent };